export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6932.49f714f7.jpg";